// The original console formula is `[40, 10, distance]`, where `distance`
// scales with content size — so its pre-rotation angle, atan2(40, distance),
// silently shifts with content size. Rotating that raw vector (an earlier
// version of this helper) meant the same rotationDeg produced a different
// absolute viewing angle depending on scene scale, and combined with the
// camera position not always reliably reaching the live Three.js camera
// (fixed separately, see CameraSync.js), that made results and the
// pre-run preview look inconsistently rotated relative to each other.
//
// Fixed by decoupling angle from distance entirely: azimuth and elevation
// are fixed viewing angles picked for a clean 3/4 view, and `distance` only
// ever controls how far away the camera sits (via zoom). Same
// rotationDeg/tiltDeg now always produces the same viewing angle regardless
// of scene scale.
const BASE_AZIMUTH_DEG = 55;
const BASE_ELEVATION_DEG = 17;

export function applyCameraTransform(distance, { zoom = 1, rotationDeg = 0, tiltDeg = 0 } = {}) {
  const radius = distance / zoom;
  const azimuth = ((BASE_AZIMUTH_DEG + rotationDeg) * Math.PI) / 180;
  const elevation = ((BASE_ELEVATION_DEG - tiltDeg) * Math.PI) / 180;
  const horiz = radius * Math.cos(elevation);
  return [horiz * Math.sin(azimuth), radius * Math.sin(elevation), horiz * Math.cos(azimuth)];
}
